export default __webpack_public_path__ + "static/media/books-1024w.ab2d521d.webp";